import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/submissions/inbox/sync-manually_/$submissionId')({});
